export const UPDATE_TARGET_LOAN_DATA = 'UPDATE_TARGET_LOAN_DATA';

export const setLoanDataTargetValue = (payload) => ({
  type: UPDATE_TARGET_LOAN_DATA,
  payload,
});
